export default __webpack_public_path__ + "static/media/twittericon.5181a4d9.svg";